import React from 'react';
import { SwitchLinkWrapper } from 'SharedComponents/styled/forms/SwitchLinkWrapper';
import ActionLink from 'SharedComponents/ActionLink';

interface SwitchLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isLoading: boolean;
    introText: string;
    ctaText: string;
}

const SwitchLink: React.FunctionComponent<SwitchLinkProps> = ({ isLoading, introText, ctaText, ...props }) => (
    <SwitchLinkWrapper>
        {introText}&nbsp;
        <ActionLink type="button" disabled={isLoading} {...props}>
            {ctaText}
        </ActionLink>
    </SwitchLinkWrapper>
);

export default SwitchLink;
